import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51cba813"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-pagination" }

import { reactive, watch } from "vue";

interface PageData {
  next: Number;
  size: Number;
  total: Number;
}

interface PageProps {
  getData: Function;
  total: Number;
  pageSizes?: any;
  size: Number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'pagination',
  props: {
    getData: {},
    total: {},
    pageSizes: { default: [10, 20, 50, 100, 200, 300, 400] },
    size: {}
  },
  setup(__props: any) {

const props = __props

const data = reactive<PageData>({
  next: 1,
  size: 20,
  total: 0,
})

const handleChange = (next, size) => {
  props.getData({ next, size });
}

watch(
  props, () => {
    data.size = props.size ? props.size : data.size
  },
  { immediate:true, deep:true }
)

return (_ctx: any,_cache: any) => {
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_pagination, _mergeProps({
      style: {"float":"right"},
      current: data.next,
      "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((data.next) = $event)),
      pageSize: data.size,
      "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((data.size) = $event)),
      "show-quick-jumper": "",
      "show-less-items": "",
      total: _ctx.total,
      onChange: handleChange
    }, _ctx.$attrs), null, 16, ["current", "pageSize", "total"])
  ]))
}
}

})